<template>
<b-tab lazy title-item-class="mr-1" :title-link-class="{'bg-danger': hasErrors, 'bg-warning': isDirty}">
    <template slot="title">
        <i v-if="isDirty || hasErrors" class="fa-solid fa-circle-exclamation" :class="{ 'fa-circle-exclamation text-white': hasErrors, 'fa-cloud-arrow-up text-black': isDirty}"></i> <i class="fa-regular fa-heart-pulse"></i> Lifestyle
    </template>
    <lifestyle-base button-top small fixed :callback="createPatientAdminLifestyle" />
</b-tab>
</template>
<script>
import TabExtension from "../TabExtension"
import LifestyleBase from "@/core/components/health/lifestyle/LifestyleBase"
import { mapActions } from "vuex"

export default TabExtension.extend({
    name: "lifestyle",
    components: {
        'lifestyle-base': LifestyleBase
    },
    methods: {
        ...mapActions('health', ['createPatientAdminLifestyle']),
    }
})
</script>
